import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Auth, Logger} from 'aws-amplify';

const logger = new Logger('i18n-logger', process.env.VUE_APP_LOGLEVEL);

@Module({ namespaced: true })
export default class I18nStore extends VuexModule {
    locale = "ESP"

    get getLocale(){
        return this.locale
    }
    @Mutation
    setLocale(value: string) {
        this.locale = value
        localStorage.setItem("locale", this.locale);
    }
    @Mutation
    shiftLocale() {
        this.locale = this.locale === "ESP" ? "ENG" : "ESP";
        localStorage.setItem("locale", this.locale);
    }

    @Action
    init() {
        let locale = localStorage.getItem("locale");
        locale = locale && locale !== "" ? locale : "ESP";
        this.context.commit("setLocale", locale);
    }

    @Action({commit: 'setLocale'})
    updateLocale(locale: string){
        return locale;
    }

    @Action({commit: 'shiftLocale'})
    changeLocale() {
        return
    }

    @Action
    fetch({module , i18n }: any ){
        return new Promise<void>((resolve) => {
            i18n.locale = this.locale;
            resolve()
        });
    }

}